export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5963.38070a6f.jpg";